import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Loader from 'features/Loader/Loader';
import {
  NOTIFICATIONS_ASSIGNER_TYPES,
  ADD_PROGRESS_IMAGES_NOTIFICATION_TYPE,
  LOGS_PRE_TRANSFORMATION_NOTIFICATION_TYPE_PREFIX,
  NOTIFICATIONS_REDIRECT_URL
} from 'utils/constants/notifications';
import { calculateLastActive, populateDate } from 'utils/date';
import { updateTrainerLastReadNotifications } from 'features/trainer/profile/ducks/trainerProfileActions';
import ItemMeal from 'features/timeline/components/itemMeal';
import ItemProgress from 'features/timeline/components/itemProgress';
import TimelineLoad from 'features/timeline/components/timelineLoad';
import NotificationsLog from './notifications-items/NotificationsLog';
import {
  getNotifications,
  getMoreNotifications
} from '../ducks/notificationsActions';

const NotificationsList = ({
  trainer,
  events,
  lastVisible,
  hasMore,
  loading,
  getNotifications,
  getMoreNotifications,
  updateTrainerLastReadNotifications
}) => {
  useEffect(() => {
    trainer.id && getNotifications(trainer.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trainer.id]);

  useEffect(() => {
    trainer.id &&
      events &&
      events.length &&
      updateTrainerLastReadNotifications(trainer.id, events[0].created_at);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events, trainer.id]);

  const handleLoadMore = () => {
    getMoreNotifications(trainer.id, lastVisible);
  };

  return loading ? (
    <Loader />
  ) : (
    <section className="notifications-list">
      <ul>
        {events?.map(event => {
          let avatarImage,
            avatarUrl,
            name = '';

          if (event.assigner_type === NOTIFICATIONS_ASSIGNER_TYPES.TRAINER) {
            avatarImage = trainer?.photo;
            avatarUrl = '/profile';
            name = `${trainer?.first_name} ${trainer?.last_name}`;
          } else {
            avatarImage = event.client_photo_url;
            avatarUrl = `/clients/${event.client_id}`;
            name = event.client_name;
          }
          const period = `${calculateLastActive(event.created_at)}`;
          var message = event.info?.message;
          var sub_message = event.info?.sub_message;
          const date = event.info?.date;
          const attempt_date = event.info?.attempt_date;

          if (message && date) message = populateDate(message, date);
          if (sub_message && attempt_date)
            sub_message = populateDate(sub_message, attempt_date);

          if (event.type === ADD_PROGRESS_IMAGES_NOTIFICATION_TYPE) {
            return (
              <li key={event.id}>
                <ItemProgress
                  avatarImage={avatarImage}
                  avatarUrl={avatarUrl}
                  name={name}
                  period={period}
                  progressImage1={
                    event.info?.urls &&
                    event.info.urls?.length &&
                    event.info.urls[0]
                  }
                  progressImage2={
                    event.info?.urls &&
                    event.info.urls?.length > 1 &&
                    event.info.urls[1]
                  }
                  progressImage3={
                    event.info?.urls &&
                    event.info.urls?.length > 2 &&
                    event.info.urls[2]
                  }
                  title={event.info?.title}
                  clientId={event.client_id}
                />
              </li>
            );
          } else if (
            event.type?.startsWith(
              LOGS_PRE_TRANSFORMATION_NOTIFICATION_TYPE_PREFIX
            )
          ) {
            return (
              <li key={event.id}>
                <ItemMeal
                  avatarImage={avatarImage}
                  avatarUrl={avatarUrl}
                  name={name}
                  period={period}
                  imageSrc={event.info?.urls && event.info.urls[0]}
                  imageLabel={event.meal_label}
                  title={event.info?.title}
                  message={message}
                  detailedMessage={sub_message}
                />
              </li>
            );
          } else {
            return (
              <li key={event.id}>
                <NotificationsLog
                  avatarImage={avatarImage}
                  avatarUrl={avatarUrl}
                  name={name}
                  period={period}
                  title={event.info?.title}
                  message={message}
                  detailedMessage={sub_message}
                  eventUrl={
                    NOTIFICATIONS_REDIRECT_URL[event.type] &&
                    NOTIFICATIONS_REDIRECT_URL[event.type](event.client_id)
                  }
                />
              </li>
            );
          }
        })}
      </ul>
      {hasMore && <TimelineLoad handleLoadMore={handleLoadMore} />}
    </section>
  );
};

function mapStateToProps(state) {
  return {
    trainer: state.trainerProfileReducer.trainer,
    events: state.notificationsReducer.events,
    lastVisible: state.notificationsReducer.lastVisible,
    hasMore: state.notificationsReducer.hasMore,
    loading: state.notificationsReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNotifications: trainerId => dispatch(getNotifications(trainerId)),
    getMoreNotifications: (trainerId, lastVisible) =>
      dispatch(getMoreNotifications(trainerId, lastVisible)),
    updateTrainerLastReadNotifications: (trainerId, date) =>
      dispatch(updateTrainerLastReadNotifications(trainerId, date))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsList);
